export default  [
    {
        path: 'opcao-entrada',
        redirect: 'opcao-entrada/index',
        component: () => import(
            /* webpackChunkName: 'painel-senha-opcao-entrada' */
            '@/views/painel-senha/opcao-entrada/Index'
        ),
        children: [
            {
                name: 'painel-senha-opcao-entrada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-opcao-entrada-index' */
                    '@/views/painel-senha/opcao-entrada/List'
                ),
            },
            {
                name: 'painel-senha-opcao-entrada-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-opcao-entrada-create' */
                    '@/views/painel-senha/opcao-entrada/Form.vue'
                ),
            },
            {
                name: 'painel-senha-opcao-entrada-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'painel-senha-opcao-entrada-edit' */
                    '@/views/painel-senha/opcao-entrada/Form.vue'
                ),
            },
        ],
    },
]